import { render, staticRenderFns } from "./BlackListedSubscribers.vue?vue&type=template&id=5d04abde&scoped=true"
import script from "./BlackListedSubscribers.vue?vue&type=script&lang=js"
export * from "./BlackListedSubscribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d04abde",
  null
  
)

export default component.exports